import { render } from "./UninvestedTransactions.vue?vue&type=template&id=1fb7e37e"
import script from "./UninvestedTransactions.vue?vue&type=script&lang=js"
export * from "./UninvestedTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script